<template>
    <div class="loginPubilc">
        <l-header />
        <router-view />
        <l-footer />
    </div>
</template>
<script>
    import lHeader from '../../components/home/header.vue'
    import lFooter from '../../components/home/footer.vue'
    export default {
        components: {
            lHeader,
            lFooter
        }
    }
</script>
<style scoped></style>